import React from 'react';
import './CommonButton.css';

/**
 * @param {string} text - 버튼 내부 텍스트
 * @param {function} onClick - 클릭 이벤트 핸들러
 * @param {string} variant - 버튼 스타일 (primary, secondary, success, danger, warning)
 * @param {boolean} disabled - 비활성화 여부
 * @param {string} className - 추가적인 커스텀 클래스가 필요할 때
 */
function CommonButton({ text, onClick, variant = 'primary', disabled = false, className = '' }) {
  return (
    <button 
      className={`common-btn btn-${variant} ${className}`} 
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
}

export default CommonButton;